document.addEventListener('DOMContentLoaded', function() {
    const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');
    
    addToCartButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            
            if (this.hasAttribute('data-sold-out') || this.classList.contains('sold-out')) {
                return;
            }
            
            const productId = this.getAttribute('data-product-id');
            const originalHTML = this.innerHTML;
            
            this.disabled = true;
            this.innerHTML = '<span>' + (window.additionalProductsTranslations ? window.additionalProductsTranslations.loading_text : 'Loading...') + '</span>';
            
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: parseInt(productId),
                        quantity: 1
                    }]
                })
            })
            .then(response => response.json())
            .then(data => {
                if (typeof window.updateCart === 'function') {
                    window.updateCart();
                }
                
                this.classList.add('added');
                this.innerHTML = '<span>' + (window.additionalProductsTranslations ? window.additionalProductsTranslations.added_text : 'Added') + '</span>';
                
                this.style.pointerEvents = 'none';
                this.style.cursor = 'not-allowed';
                
                setTimeout(() => {
                    const vexModal = document.querySelector('.vex.vex-theme-plain');
                    const vexOverlay = document.querySelector('.vex-overlay');
                    
                    if (vexModal) {
                        vexModal.style.display = 'none';
                        vexModal.style.visibility = 'hidden';
                        vexModal.style.opacity = '0';
                        vexModal.style.pointerEvents = 'none';
                    }
                    
                    if (vexOverlay) {
                        vexOverlay.style.display = 'none';
                        vexOverlay.style.visibility = 'hidden';
                        vexOverlay.style.opacity = '0';
                        vexOverlay.style.pointerEvents = 'none';
                    }
                    
                    document.body.classList.remove('vex-open');
                }, 200);
            })
            .catch(error => {
                console.error('Error:', error);
                
                this.disabled = false;
                this.classList.add('error');
                this.innerHTML = '<svg class="t4s-btn-icon" viewBox="0 0 24 24"><use xlink:href="#t4s-icon-error"></use></svg><span>' + (window.additionalProductsTranslations ? window.additionalProductsTranslations.error_text : 'Error') + '</span>';
                
                setTimeout(() => {
                    this.disabled = false;
                    this.classList.remove('error');
                    this.innerHTML = originalHTML;
                }, 3000);
            });
        });
    });
}); 